export const currencies = [
  { code: 'EUR', name: 'Euro', nameDe: 'Euro' },
  { code: 'USD', name: 'US Dollar', nameDe: 'US-Dollar' },
  { code: 'GBP', name: 'British Pound', nameDe: 'Britisches Pfund' },
  { code: 'JPY', name: 'Japanese Yen', nameDe: 'Japanischer Yen' },
  { code: 'AUD', name: 'Australian Dollar', nameDe: 'Australischer Dollar' },
  { code: 'CAD', name: 'Canadian Dollar', nameDe: 'Kanadischer Dollar' },
  { code: 'CHF', name: 'Swiss Franc', nameDe: 'Schweizer Franken' },
  { code: 'CNY', name: 'Chinese Yuan', nameDe: 'Chinesischer Yuan' },
  { code: 'SEK', name: 'Swedish Krona', nameDe: 'Schwedische Krone' },
  { code: 'NOK', name: 'Norwegian Krone', nameDe: 'Norwegische Krone' },
  { code: 'DKK', name: 'Danish Krone', nameDe: 'Dänische Krone' },
  { code: 'PLN', name: 'Polish Zloty', nameDe: 'Polnischer Zloty' },
  { code: 'CZK', name: 'Czech Koruna', nameDe: 'Tschechische Krone' },
  { code: 'HUF', name: 'Hungarian Forint', nameDe: 'Ungarischer Forint' },
  { code: 'RON', name: 'Romanian Leu', nameDe: 'Rumänischer Leu' },
  { code: 'TRY', name: 'Turkish Lira', nameDe: 'Türkische Lira' },
  { code: 'RUB', name: 'Russian Ruble', nameDe: 'Russischer Rubel' },
  { code: 'INR', name: 'Indian Rupee', nameDe: 'Indische Rupie' },
  { code: 'MXN', name: 'Mexican Peso', nameDe: 'Mexikanischer Peso' },
  { code: 'ZAR', name: 'South African Rand', nameDe: 'Südafrikanischer Rand' },
  { code: 'BRL', name: 'Brazilian Real', nameDe: 'Brasilianischer Real' },
  { code: 'TWD', name: 'Taiwan Dollar', nameDe: 'Taiwan-Dollar' },
  { code: 'THB', name: 'Thai Baht', nameDe: 'Thailändischer Baht' },
  { code: 'IDR', name: 'Indonesian Rupiah', nameDe: 'Indonesische Rupiah' },
  { code: 'ILS', name: 'Israeli Shekel', nameDe: 'Israelischer Schekel' },
  { code: 'PHP', name: 'Philippine Peso', nameDe: 'Philippinischer Peso' },
  { code: 'AED', name: 'UAE Dirham', nameDe: 'VAE-Dirham' },
  { code: 'CLP', name: 'Chilean Peso', nameDe: 'Chilenischer Peso' },
  { code: 'COP', name: 'Colombian Peso', nameDe: 'Kolumbianischer Peso' },
  { code: 'SAR', name: 'Saudi Riyal', nameDe: 'Saudi-Arabischer Riyal' },
  { code: 'MYR', name: 'Malaysian Ringgit', nameDe: 'Malaysischer Ringgit' },
  { code: 'SGD', name: 'Singapore Dollar', nameDe: 'Singapur-Dollar' },
  { code: 'NZD', name: 'New Zealand Dollar', nameDe: 'Neuseeland-Dollar' },
  { code: 'HKD', name: 'Hong Kong Dollar', nameDe: 'Hongkong-Dollar' },
  { code: 'ARS', name: 'Argentine Peso', nameDe: 'Argentinischer Peso' }
];